import { Injectable, Optional, OnInit } from '@angular/core';
import { AppCacheService } from '../cache/app-cache.service';
import { TypeRef } from './type-ref';
import { TypeGroup } from './type-group';
import { AppPreference } from './app-preference';
import { Message } from './message';
import { CacheName } from '../../constants/cache.constants';
import { StatRef } from './stat-ref';
import { MasterEntity } from './master-entity';

@Injectable()
export class StaticService {
  /*********************Properties*********************/
  private readonly staticItems = {
    AppPreferences: {
      Selector: CacheName.Static.AppPreferences,
      Property: 'preferenceKey'
    },
    Messages: { Selector: CacheName.Static.Messages, Property: 'messageId' },
    TypeGroups: {
      Selector: CacheName.Static.TypeGroups,
      Property: 'typeGroupCode'
    },
    TypeRefs: { Selector: CacheName.Static.TypeRefs, Property: 'typeCode' },
    StatRefs: { Selector: CacheName.Static.StatRefs, Property: 'statCode' },
    MasterEntity: {Selector: CacheName.Static.MasterEntityData, Property: 'key'}
  };

  readonly appPreference: AppPreference;
  readonly message: Message;
  readonly typeRef: TypeRef;
  readonly typeGroup: TypeGroup;
  readonly statRef: StatRef;
  readonly masterEntity: MasterEntity;
  /*********************Properties*********************/

  /*********************Constructor*********************/
  constructor(private cache: AppCacheService) {
    this.appPreference = new AppPreference(
      this.staticItems.AppPreferences.Selector,
      this.staticItems.AppPreferences.Property,
      this.cache
    );

    this.masterEntity = new MasterEntity(
      this.staticItems.MasterEntity.Selector,
      this.staticItems.MasterEntity.Property,
      this.cache
    );

    this.message = new Message(
      this.staticItems.Messages.Selector,
      this.staticItems.Messages.Property,
      this.cache
    );

    this.typeRef = new TypeRef(
      this.staticItems.TypeRefs.Selector,
      this.staticItems.TypeRefs.Property,
      this.cache
    );

    this.typeGroup = new TypeGroup(
      this.staticItems.TypeGroups.Selector,
      this.staticItems.TypeGroups.Property,
      this.cache
    );

    this.statRef = new StatRef(
      this.staticItems.StatRefs.Selector,
      this.staticItems.StatRefs.Property,
      this.cache
    );
  }
  /*********************Constructor*********************/
}
